import moment from 'moment';

import { PAGINATION_DEFAULT_VALUE } from '../defaultValue';

export const buildScenarioQueryParams = (query) => {
    const result = {
        page: (query.get('page') || PAGINATION_DEFAULT_VALUE.currentPage).toString(),
        page_size: (query.get('page_size') || PAGINATION_DEFAULT_VALUE.pageSize).toString(),
        sort_by: query.get('sort_by') || null,
    };

    const integrationId = query.get('integrationId');
    if (integrationId) {
        if (integrationId.toLowerCase() === 'commerceship') {
            result.cs = true;
        } else {
            result.cs = false;
            result.integrationId = integrationId;
        }
    }

    if (query.has('comparisonRateType')) result.comparisonRateType = query.get('comparisonRateType');
    if (query.has('carrier')) result.comparisonCarrier = query.get('carrier');
    if (query.has('priceTypeCategory')) result.priceTypeCategory = query.get('priceTypeCategory');

    if (query.has('shipStartDate')) {
        result.shipStartDate = moment(query.get('shipStartDate')).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('shipEndDate')) {
        result.shipEndDate = moment(query.get('shipEndDate')).format('YYYY-MM-DDTHH:mm:ss');
    }

    if (query.has('domestic') && query.get('domestic') !== 'all') {
        result.domestic = query.get('domestic') === 'domestic';
    }

    if (query.has('ground') && query.get('ground') !== 'all') {
        result.ground = query.get('ground') === 'ground';
    }

    if (query.has('service_levels')) {
        result.serviceLevelGroups = query.getAll('service_levels');
    }

    if (query.has('warehouse_id')) {
        result.warehouseIds = query.getAll('warehouse_id');
    }

    if (query.has('zones')) {
        result.zones = query.getAll('zones');
    }

    if (query.has('carriers')) {
        result.carriers = query.getAll('carriers');
    }

    if (query.has('to_state')) {
        result.toStates = query.getAll('to_state');
    }

    if (query.has('trackingNumber')) {
        result.trackingNumbers = query.getAll('trackingNumber');
    }

    if (query.has('induction_postal_code')) {
        result.inductionPostalCodes = query.getAll('induction_postal_code');
    }

    if (query.has('matches') && query.get('matches') !== 'all') {
        result.matches = query.get('matches') === 'true';
    }

    if (query.has('matchThreshold')) {
        result.matchThreshold = query.get('matchThreshold');
    }

    if (query.has('timeframe')) {
        result.timeframe = query.get('timeframe');
    }

    if (query.has('format')) {
        result.format = query.get('format');
    }

    return result;
};
